<template>
  <login-signup :style="mobile ? 'padding-top: 30px;' : 'margin-top: 30px;'"></login-signup>
</template>

<script>
import { mapGetters } from 'vuex'

import { LoginSignup } from '@/components'

const name = 'login'

const computed = {
  ...mapGetters({
    mobile: 'ux/mobile'
  })
}

const components = {
  LoginSignup
}

export default {
  name,
  computed,
  components,
  metaInfo: {
    title: 'Login'
  },
  beforeMount () {
    if (this.$auth.authenticated === true) {
      this.$router.replace({ name: 'home' })
    }
  }
}
</script>
